import { Church } from 'lucide-react';
import { Input } from '~/components/ui/input';
import { Label } from '~/components/ui/label';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '~/components/ui/card';

interface ChurchAffiliation {
  churchName?: string;
  pastorName?: string;
  churchEmail?: string;
}

interface ChurchAffiliationFormProps {
  churchAffiliation: ChurchAffiliation;
  onChange: (field: string, value: string) => void;
}

export function ChurchAffiliationForm({ churchAffiliation, onChange }: ChurchAffiliationFormProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg flex items-center gap-2">
          <Church className="h-5 w-5" />
          Church Affiliation
        </CardTitle>
        <CardDescription>
          Your family's church or place of worship (optional)
        </CardDescription>
      </CardHeader>
      <CardContent className="space-y-4">
        <div className="space-y-2">
          <Label htmlFor="churchName">Church Name</Label>
          <Input
            id="churchName"
            value={churchAffiliation.churchName || ''}
            onChange={(e) => onChange('churchName', e.target.value)}
            placeholder="Name of your church"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="pastorName">Pastor/Minister Name</Label>
          <Input
            id="pastorName"
            value={churchAffiliation.pastorName || ''}
            onChange={(e) => onChange('pastorName', e.target.value)}
            placeholder="Name of your pastor or minister"
          />
        </div>
        <div className="space-y-2">
          <Label htmlFor="churchEmail">Church Contact Email</Label>
          <Input
            id="churchEmail"
            type="email"
            value={churchAffiliation.churchEmail || ''}
            onChange={(e) => onChange('churchEmail', e.target.value)}
            placeholder="church@example.com"
          />
        </div>
      </CardContent>
    </Card>
  );
}
